import styles from './TermsOfService.module.css'

export function TermsOfService() {
    return (
        <div className={styles.container}>
            <h1 className={styles.title}>Términos de Servicio</h1>
            <div className={styles.content}>
                <p className={styles.updated}>Última actualización: Marzo 2026</p>

                <section className={styles.section}>
                    <h2>1. Aceptación de los Términos</h2>
                    <p>Al utilizar Imprime Digital, aceptas estos términos de servicio. Si no estás de acuerdo con alguna parte de estos términos, no debes utilizar nuestros servicios.</p>
                </section>

                <section className={styles.section}>
                    <h2>2. Descripción del Servicio</h2>
                    <p>Imprime Digital es una plataforma de diseño e impresión que permite:</p>
                    <ul>
                        <li>Crear diseños gráficos utilizando nuestro editor en línea.</li>
                        <li>Utilizar asistencia de inteligencia artificial para generar diseños.</li>
                        <li>Ordenar impresiones de tus diseños con entrega a nivel nacional en Perú.</li>
                    </ul>
                </section>

                <section className={styles.section}>
                    <h2>3. Cuenta de Usuario</h2>
                    <p>Eres responsable de mantener la confidencialidad de tu cuenta y contraseña. Debes notificarnos inmediatamente sobre cualquier uso no autorizado de tu cuenta.</p>
                </section>

                <section className={styles.section}>
                    <h2>4. Propiedad Intelectual</h2>
                    <p>Los diseños que crees usando nuestra plataforma son de tu propiedad. Sin embargo, nos otorgas una licencia limitada para almacenar, procesar e imprimir tus diseños con el propósito de cumplir tus pedidos.</p>
                    <p>No debes subir contenido que infrinja derechos de autor, marcas registradas u otros derechos de propiedad intelectual de terceros.</p>
                </section>

                <section className={styles.section}>
                    <h2>5. Pedidos e Impresión</h2>
                    <ul>
                        <li>Los precios se muestran en Soles peruanos (S/) e incluyen IGV.</li>
                        <li>Los pedidos confirmados no pueden ser cancelados una vez que entran en estado de impresión.</li>
                        <li>Los tiempos de entrega son estimados y pueden variar según la ubicación.</li>
                        <li>Nos reservamos el derecho de rechazar pedidos con contenido ilegal o inapropiado.</li>
                    </ul>
                </section>

                <section className={styles.section}>
                    <h2>6. Pagos</h2>
                    <p>Aceptamos pagos mediante Yape, Plin, transferencia bancaria y otros métodos habilitados. El pago debe ser verificado antes de que el pedido entre en producción.</p>
                </section>

                <section className={styles.section}>
                    <h2>7. Devoluciones y Reclamos</h2>
                    <p>Si el producto impreso presenta defectos de impresión o daños durante el envío, puedes solicitar una reimpresión o reembolso dentro de los 7 días calendario posteriores a la recepción. No se aceptan devoluciones por errores de diseño del usuario.</p>
                </section>

                <section className={styles.section}>
                    <h2>8. Uso de IA</h2>
                    <p>Los diseños generados por inteligencia artificial son herramientas de asistencia. El usuario es responsable de revisar y aprobar el diseño final antes de ordenar la impresión.</p>
                </section>

                <section className={styles.section}>
                    <h2>9. Limitación de Responsabilidad</h2>
                    <p>Imprime Digital no será responsable por daños indirectos, incidentales o consecuentes derivados del uso de nuestros servicios. Nuestra responsabilidad máxima se limita al monto pagado por el pedido en cuestión.</p>
                </section>

                <section className={styles.section}>
                    <h2>10. Ley Aplicable</h2>
                    <p>Estos términos se rigen por las leyes de la República del Perú. Cualquier disputa se resolverá ante los tribunales competentes de Lima, Perú.</p>
                </section>

                <section className={styles.section}>
                    <h2>11. Contacto</h2>
                    <p>Para consultas sobre estos términos: info@qolca.org</p>
                </section>
            </div>
        </div>
    )
}
